// src/main.ts
import {enableProdMode} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';
import {provideAnimations} from '@angular/platform-browser/animations';
import {AppComponent} from './app/app.component';
import {appConfig} from './app/app.config';
import {environment} from './environments/environment';
import { register as registerSwiperElements } from 'swiper/element/bundle';
import { addIcons } from 'ionicons';
import { hugeicons } from './app/core/icons/hugeicons.icons';
import { applyNavigationChromeClass } from './app/core/platform/navigation-chrome';

registerSwiperElements();

// Registro global de íconos hugeicons (una sola vez para toda la app,
// ver src/app/core/icons/hugeicons.icons.ts)
addIcons(hugeicons);

// Formato de la barra de título según el equipo (iOS en teléfono/tablet, más grande con flecha en web)
applyNavigationChromeClass();

// AngularFire (standalone)
import {provideFirebaseApp, initializeApp} from '@angular/fire/app';
import {provideAuth, getAuth} from '@angular/fire/auth';
// Agrega más según uses: Firestore, Storage, etc.
// import { provideFirestore, getFirestore } from '@angular/fire/firestore';
// import { provideStorage, getStorage } from '@angular/fire/storage';

// Firebase Analytics NO se registra acá a propósito (sin `provideAnalytics`).
// La Declaración de Privacidad (§2) promete que las cookies de analítica solo
// se activan con opt-in previo del usuario. `AnalyticsService`
// (src/app/core/legal/analytics.service.ts) la carga por `import()` dinámico
// solo cuando `CookieConsentService.granted('analytics')` es true — nunca en
// el arranque.

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [
        ...(appConfig.providers || []),
        provideAnimations(),

        // Firebase App (una sola vez)
        provideFirebaseApp(() => initializeApp(environment.firebase)),

        // Auth (y los que necesites)
        provideAuth(() => getAuth()),
        // provideFirestore(() => getFirestore()),
        // provideStorage(() => getStorage()),
    ],
}).catch(err => console.error(err));
